// services/vendor.ts
import api from './api';
import { Vendor, VendorMember } from '../types/vendor';

// export const vendorService = {
//     async getAllVendors(): Promise<Vendor[]> {
//         const response = await api.get('/vendors/list');
//         return response.data.vendors;
//     },

//     async getVendorMembers(vendorId: number): Promise<VendorMember[]> {
//         const response = await api.get(`/vendors/${vendorId}/members`);
//         return response.data.members;
//     },

//     async getAllVendorMembers(): Promise<VendorMember[]> {
//         const response = await api.get('/vendors/members/list');
//         return response.data.members;
//     }
// };


export const vendorService = {
    async getAllVendors(): Promise<Vendor[]> {
        const response = await api.get('/vendors/list');
        return response.data.vendors;
    },

    async getAllVendorMembers(): Promise<VendorMember[]> {
        const response = await api.get('/vendors/members/list');
        return response.data.members;
    },

    async getVendorMembers(vendorId: number): Promise<VendorMember[]> {
        const response = await api.get(`/vendors/${vendorId}/members`);
        return response.data.members;
    }
};